//#region src/menu_item_category.ts
var MenuItemCategory = /* @__PURE__ */ function(MenuItemCategory) {
	MenuItemCategory[MenuItemCategory["Food"] = 0] = "Food";
	MenuItemCategory[MenuItemCategory["AlcoholicBeverage"] = 1] = "AlcoholicBeverage";
	MenuItemCategory[MenuItemCategory["NonalcoholicBeverage"] = 2] = "NonalcoholicBeverage";
	MenuItemCategory[MenuItemCategory["Other"] = 3] = "Other";
	MenuItemCategory[MenuItemCategory["SpecialOffer"] = 4] = "SpecialOffer";
	return MenuItemCategory;
}(MenuItemCategory || {});
//#endregion
export { MenuItemCategory };

//# sourceMappingURL=menu_item_category.js.map